import {
  EVENT_ACTION_BUTTON_CLICKED,
  EVENT_ACTION_SCREEN_DISPLAYED,
  EVENT_ACTIVITY,
  EVENT_CATEGORY,
  EVENT_CONTROL_DETAIL_USER_CLICKED_REFRESH,
  EVENT_CONTROL_DETAIL_USER_LOGGED_IN,
  EVENT_CONTROL_LOG_IN,
  EVENT_CONTROL_REFRESH_BUTTON_CLICKED,
  EVENT_DETAIL_TYPE,
  EVENT_DETAIL_VERSION,
  EVENT_SCREEN_NAME,
  EVENT_SCREEN_PATH,
  EVENT_VERSION
} from './constants'

const activity = EVENT_ACTIVITY
const eventDetailVersion = EVENT_DETAIL_VERSION
const screenPath = EVENT_SCREEN_PATH

export const publishEvent = (analytics, eventDetail) => {
  const publishCdmEvents = analytics.publishCdmEvents

  if (!publishCdmEvents) {
    return
  }

  eventDetail.activity = activity

  publishCdmEvents([
    {
      dateTime: new Date().toISOString(),
      eventDetailType: EVENT_DETAIL_TYPE,
      eventCategory: EVENT_CATEGORY,
      eventDetail,
      version: EVENT_VERSION
    }
  ])
}

// Events

export const DashBoardIsDisplayed = () => {
  return {
    action: EVENT_ACTION_SCREEN_DISPLAYED,
    controlDetail: EVENT_CONTROL_DETAIL_USER_LOGGED_IN,
    controlName: EVENT_CONTROL_LOG_IN,
    screenName: EVENT_SCREEN_NAME,
    screenPath,
    version: eventDetailVersion
  }
}

export const RefreshButtonClicked = () => {
  return {
    action: EVENT_ACTION_BUTTON_CLICKED,
    controlDetail: EVENT_CONTROL_DETAIL_USER_CLICKED_REFRESH,
    controlName: EVENT_CONTROL_REFRESH_BUTTON_CLICKED,
    screenName: EVENT_SCREEN_NAME,
    screenPath,
    version: eventDetailVersion
  }
}

// Interfaces

export type ActiveUserType = {
  resourceId: string
}

export type AnalyticsEventPropType = {
  action: string
  activity: string
  screenPath: string
  screenName: string
  screenMode: string
  controlName: string
  controlDetail: string
  version: string
}
